var regex = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;

export const validarUrl = {

  messages: {
    pt_BR: (field) => {
      return `O campo ${field} não é válido.`;
    },
  },
  validate(value) {
    return regex.test(value);
  },
};



// WEBPACK FOOTER //
// ./src/custom-validations.js